import React, { useContext } from "react";
import {
  Stack,
  DefaultPalette,
  Link,
  Spinner,
  SpinnerSize,
} from "@fluentui/react";

import { Footer } from "./Footer";
import LogoWidget from "./LogoWidget";
import { SignInForm } from "./SignInForm";
import { OandoLogo } from "./OandoLogo";
import { AccountRequest } from "./AccountRequest";
import { observer } from "mobx-react-lite";
import HomeStore from "../store/homestore";
import { ResetPassword } from "./ResetPassword";
import { Offline } from "react-detect-offline";

import { notification } from "antd";
import { ApiOutlined } from "@ant-design/icons";
const shrinkingStackItemStyle = {
  root: {
    textAlign: "center",
    background: "url(/images/loginbackground.png)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
  },
};
const nonShrinkingStackItemStyles = {
  root: {
    background: DefaultPalette.white,
    color: DefaultPalette.white,
    display: "flex",

    margin: "0px 0px 0px",

    justifyContent: "center",

    minWidth: 400,
    maxWidth: "40%",
  },
};

export const Login = observer(() => {
  const homeStore = useContext(HomeStore);

  return (
    <React.Fragment>
      <Offline
        onChange={(args) => {
          if (args === true) {
            notification.success({
              message: `Connected `,
              description: "successfully connected to the internet",
              placement: "bottomRight",
            });
          } else {
            notification.warning({
              message: `Not Connected `,
              description:
                "it looks like you're not connected to the internet or temporarily disconnected,please check your internet connection",
              placement: "bottomRight",
              icon: <ApiOutlined style={{ color: "red" }} />,
            });
          }
        }}
      ></Offline>

      <Stack horizontal>
        <Stack.Item grow styles={shrinkingStackItemStyle}>
          <div className="ms-Grid-row">
            <div
              className="ms-Grid-col ms-sm12"
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "10%",
                fontSize: "5vw",
              }}
            >
              <span className="ms-fontColor-sharedOrange10">SPA</span>
              <span className="ms-fontColor-sharedCyanBlue10">RS</span>

              <div style={{ fontSize: "1vw", color: "#A0AEC0" }}>
              R2026.1.113
              </div>
            </div>
            <div
              style={{ fontSize: "1vw", fontWeight: "bold", color: "#718096" }}
              className="font-sans"
            >
              Integrated Oil & Gas Production Digitalization Platform.
            </div>
          </div>

          <div style={{ position: "absolute", top: "0px", width: "100%" }}>
            <Footer />
          </div>
        </Stack.Item>

        <Stack.Item styles={nonShrinkingStackItemStyles}>
          <Stack
            tokens={{
              childrenGap: 10,
              padding: 10,
            }}
            style={{ width: "80%" }}
          >
            <Stack.Item>
              <div className="ms-Grid" dir="ltr" style={{ color: "black" }}>
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12  ">
                    <LogoWidget />
                  </div>
                </div>
              </div>
            </Stack.Item>
            <div className="ms-Grid" dir="ltr" style={{ color: "black" }}>
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12">
                  <SignInForm />
                </div>
              </div>
              {homeStore.loginInProgress && (
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12">
                    {" "}
                    <Spinner
                      label="confirming your credential, please wait..."
                      ariaLive="assertive"
                      labelPosition="right"
                      size={SpinnerSize.large}
                    />
                  </div>
                </div>
              )}
              <div className="ms-Grid-row" style={{ marginTop: "25px" }}>
                <div className="ms-Grid-col ms-sm6 ms-fontSize-12">
                  <span>
                    Don't have SPARS Account?
                    <br />
                    <Link
                      onClick={() => {
                        homeStore.showRequestAccountDialog = true;
                      }}
                    >
                      Request for an account{" "}
                    </Link>
                  </span>
                </div>
                <div
                  className="ms-Grid-col ms-sm6 ms-fontSize-12"
                  style={{ textAlign: "left" }}
                >
                  <span>
                    Forgot your SPARS Password?
                    <br />
                    <Link
                      onClick={() => {
                        homeStore.showpasswordResetDialog = true;
                      }}
                    >
                      Reset your password{" "}
                    </Link>
                  </span>
                </div>
              </div>
            </div>

            <OandoLogo />
            <ResetPassword />
          </Stack>
        </Stack.Item>
      </Stack>
      <AccountRequest />
    </React.Fragment>
  );
});

